import { Stage } from 'utils/types';

const stages = ({ data, meta }: { data: Stage[]; meta: any }) => ({
  meta,
  data: data.sort((a, b) => a.sequence - b.sequence),
});

export default { stages };
